import React from 'react';
import { CampaignCardSkeleton } from '../../../campaign-card/CampaignCardSkeleton';
import { CampaignCardsFeedProps } from '../../campaign-cards-feed-props';

export function CampaignCardsFeedCarouselSkeleton(arg: {
  props: CampaignCardsFeedProps;
  animated?: boolean;
}) {
  const { animated = true } = arg;
  const { nbColumns = 3 } = arg.props;
  const skeletons = Array.from({ length: nbColumns });

  return (
    <div
      className="campaign-cards-grid qlf-skeleton"
      style={{
        display: 'grid',
        gap: '1rem',
        alignItems: 'stretch',
        gridTemplateColumns: `repeat(${nbColumns}, minmax(0, 1fr))`,
        flexGrow: 1,
        flex: 1,
        marginLeft: '2.5rem',
        marginRight: '2.5rem',
      }}
    >
      {skeletons.map((_, index) => (
        <CampaignCardSkeleton key={index} animated={animated} />
      ))}
    </div>
  );
}
